import { render, staticRenderFns } from "./loading-modal.vue?vue&type=template&id=77815285&scoped=true"
import script from "./loading-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./loading-modal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77815285",
  null
  
)

export default component.exports